import { render, staticRenderFns } from "./DSDevelopersIcon.vue?vue&type=template&id=ca29cbd8&scoped=true&"
import script from "./DSDevelopersIcon.vue?vue&type=script&lang=js&"
export * from "./DSDevelopersIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca29cbd8",
  null
  
)

export default component.exports